<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>编辑订单信息</p>
      </div>
    </div>

    <!-- 学员信息 -->
    <div class="detail-head">
      <div class="user-content">
        <p class="title">
          <span>学员信息</span>
        </p>
        <p class="title info">
          <span class="name">{{ mainData.student.name }}</span>
          <span class="mobile"
            >{{
              mainData.student.area_code ? "+" + mainData.student.area_code : ""
            }}
            {{ mainData.student.mobile }}</span
          >
        </p>
      </div>
    </div>

    <!-- 购课，只能编辑部分参数 -->
    <div v-if="$route.query.type === 'complete' && mainData.order_type === 1">
      <div class="table-wrap course" v-if="tableCourseList.length > 0">
        <div class="table-title">课程</div>
        <div class="th">
          <div class="td">购买内容</div>
          <div class="td">业务形式</div>
          <div class="td">内容价格</div>
          <div class="td">购买数量</div>
          <div class="td">总价</div>
          <div class="td">赠送数量</div>
          <div class="td">直减</div>
          <div class="td">小计</div>
          <div class="td">操作</div>
        </div>
        <div class="item" v-for="item in tableCourseList" :key="item.item_name">
          <p class="title">
            【{{ item.is_combo ? "课程" : "套餐" }}】-
            {{ item.item_name }}
          </p>
          <div class="tr" v-for="it in item.list" :key="it.course_id">
            <!-- 购买内容 -->
            <div class="td">{{ it.course_name }}</div>
            <!-- 业务类型 -->
            <div class="td">
              <p v-if="it.business_type === 0">-</p>
              <p v-if="it.business_type === 2">续费</p>
              <p v-if="it.business_type === 1">新购</p>
              <p v-if="it.business_type === 3">拓科</p>
            </div>
            <!-- 内容价格 -->
            <div class="td">
              <el-input v-if="it.spec_name" v-model="it.spec_name" disabled>
              </el-input>
              <el-input v-else v-model="it.unit_price" disabled> </el-input>
            </div>
            <!-- 购买数量 -->
            <div class="td">
              <el-input
                :style="{ width: '40px' }"
                v-model="it.quantity"
                disabled
                type="number"
              >
              </el-input>
              课时
            </div>
            <!-- 总价 -->
            <div class="td">
              <el-input
                :style="{ width: it.amount.length * 10 + 20 + 'px' }"
                v-model="it.amount"
                disabled
                type="number"
              >
                <template slot="prepend">￥</template>
              </el-input>
            </div>
            <!-- 赠送数量 -->
            <div class="td">
              <el-input
                :style="{
                  width: '40px',
                  minWidth: '40px',
                }"
                v-model="it.give_product_quantity"
                type="number"
                @change="handleGiveProductQuantity(it)"
              ></el-input>
              课时
            </div>
            <!-- 直减 -->
            <div class="td">
              <el-select v-model="value" disabled :style="{ width: 80 + 'px' }">
                <el-option label="直减" :value="value"></el-option>
              </el-select>
              <el-input
                :style="{ width: it.discount_amount.length * 10 + 20 + 'px' }"
                v-model="it.discount_amount"
                type="number"
                disabled
              >
                <template slot="prepend">￥</template>
              </el-input>
            </div>
            <!-- 小计 -->
            <div class="td">
              <el-input
                :style="{ width: it.receivable_amount.length * 10 + 20 + 'px' }"
                v-model="it.receivable_amount"
                type="number"
                disabled
              >
                <template slot="prepend">￥</template>
              </el-input>
            </div>
            <div class="td"></div>
          </div>
          <div class="date-wrap">
            <span class="label">课程有效期：</span>
            <el-date-picker
              v-model="item.efficient_time"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            <el-tooltip
              effect="dark"
              content="超过有效期的课程，会显示过期标签"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="table-wrap product" v-if="tableProductList.length > 0">
        <div class="table-title">物品服务</div>
        <div class="th">
          <div class="td">购买内容</div>
          <div class="td">内容价格</div>
          <div class="td">购买数量</div>
          <div class="td">总价</div>
          <div class="td">直减</div>
          <div class="td">小计</div>
          <div class="td">操作</div>
        </div>
        <div
          class="item"
          v-for="item in tableProductList"
          :key="item.item_name"
        >
          <p class="title">
            【{{ item.item_type === 2 ? "物品" : "服务" }}】-
            {{ item.item_name }}
          </p>
          <div class="tr" v-for="it in item.list" :key="it.course_id">
            <!-- 购买内容 -->
            <div class="td">{{ it.course_name }}</div>
            <!-- 内容价格 -->
            <div class="td">
              <el-input v-model="it.spec_unit_price" disabled></el-input>
            </div>
            <!-- 购买数量 -->
            <div class="td">
              <el-input
                :style="{ width: '40px' }"
                v-model="it.quantity"
                disabled
                type="number"
              >
              </el-input>
              课时
            </div>
            <!-- 总价 -->
            <div class="td">
              <el-input
                :style="{ width: it.amount.length * 10 + 20 + 'px' }"
                v-model="it.amount"
                disabled
                type="number"
              >
                <template slot="prepend">￥</template>
              </el-input>
            </div>
            <!-- 直减 -->
            <div class="td">
              <el-select v-model="value" disabled :style="{ width: 80 + 'px' }">
                <el-option label="直减" :value="value"></el-option>
              </el-select>
              <el-input
                :style="{ width: it.discount_amount.length * 10 + 20 + 'px' }"
                v-model="it.discount_amount"
                type="number"
                disabled
              >
                <template slot="prepend">￥</template>
              </el-input>
            </div>
            <!-- 小计 -->
            <div class="td">
              <el-input
                :style="{ width: it.receivable_amount.length * 10 + 20 + 'px' }"
                v-model="it.receivable_amount"
                type="number"
                disabled
              >
                <template slot="prepend">￥</template>
              </el-input>
            </div>
            <div class="td"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 部分付款时可编辑全部订单内容 -->
    <div
      v-if="$route.query.type === 'partially'"
      style="margin: 0 72px 32px 72px"
    >
      <orderContent
        ref="editableOrderContent"
        :student-id="mainData.student.student_id"
        :origin-order-data="mainData.item"
      ></orderContent>
    </div>
    <!-- 收款明细 -->
    <div class="pay-log-table">
      <p class="title">收款明细</p>
      <el-table
        size="mini"
        :data="payLogTableData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        class="mwow-table"
      >
        <el-table-column label="序号">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="支付时间" prop="payment_time"></el-table-column>
        <el-table-column
          label="支付金额"
          prop="payment_amount"
        ></el-table-column>
        <el-table-column label="支付方式" prop="payment_name"></el-table-column>
        <el-table-column label="操作人" prop="staff.name"></el-table-column>
      </el-table>
      <p class="total">
        已付金额：<span class="number">￥{{ payLogTableTotal }}</span>
      </p>
    </div>

    <!-- 基本信息 -->
    <div class="block mwow-form">
      <p class="title" style="font-weight: bold">基本信息</p>
      <el-row>
        <el-col :span="18">
          <div class="item">
            <span class="label">支付时间：</span>
            <span class="content">
              <el-date-picker
                v-model="mainData.handle_time"
                type="datetime"
                placeholder="选择日期时间"
                format="yyyy-MM-dd HH:mm"
                disabled
              >
              </el-date-picker>
            </span>
          </div>
          <div class="item">
            <span class="label" style="margin-right: 78px"
              >创建人：{{ username }}</span
            >
            <span class="label">
              <span style="color: red">*&nbsp;</span>
              业务人员：<br />
              <span style="color: #f56c6c" v-show="showBusinessPerson"
                >请选择业务人员</span
              >
            </span>
            <div class="content belong-wrap">
              <span
                class="tag"
                v-for="item in staffCheckedData"
                :key="item.staff_id"
                >{{ item.name }}</span
              >
              <addStaffDialog
                :originData="staffCheckedData"
                @change="addStaffChange"
                v-if="$route.query.type === 'complete'"
              >
                <!-- 在子组件内放置一个默认插槽，用来触发显示 addStaffDialog 组件 -->
                <span class="btn">添加员工</span>
              </addStaffDialog>
            </div>
          </div>
          <div class="item">
            <span class="label">
              <span
                style="color: red"
                v-if="showStar || $route.query.type === 'partially'"
                >*</span
              >
              其他备注：
            </span>
            <span class="content mwow-yellow"
              >如订单有赠送课时、直减金额，请在下方备注说明</span
            >
          </div>
          <div class="item">
            <span class="label"></span>
            <div class="content">
              <el-input
                v-model="mainData.remark"
                type="textarea"
                placeholder="请输入描述"
                @change="handleRemark"
              ></el-input>
              <span style="color: #f56c6c" v-show="showRemark"
                >请填写备注说明</span
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="foot-btn-wrap">
      <div class="mwow-button-filled" v-debounce="1000" @click="$router.go(-1)">
        取消
      </div>
      <div
        class="mwow-button-filled success"
        v-debounce="1000"
        @click="saveConfirm"
      >
        保存
      </div>
    </div>
  </div>
</template>

<script>
import {
  orderDetail,
  approvalRejectEditApi,
  getPaymentDetailApi,
  editPartiallyPayOrderApi,
} from "@/api/order";
import { UserModule } from "@/store/module/user";
import { dateFormat } from "@/utils/timeFormat";
import addStaffDialog from "@/components/addStaffDialog.vue";
import orderContent from "./orderContent.vue";
export default {
  components: {
    addStaffDialog,
    orderContent,
  },
  data() {
    return {
      mainData: {
        student: {},
        payment_list: [],
        handle_time: "",
        transfer_join_student: {},
        remark: "",
        item: [],
      },
      partiallyPay: 0, // 订单已部分支付的金额
      showBusinessPerson: false, // 是否选择业务人员
      staffCheckedData: [], // 人员选择
      value: "",
      showStar: false,
      showRemark: false,
      payLogTableData: [],
      payLogTableTotal: 0,
    };
  },
  computed: {
    username() {
      return UserModule.userInfo.staff_name;
    },
    tableCourseList() {
      return this.mainData.item.filter((item) => {
        return item.item_type === 1;
      });
    },
    tableProductList() {
      return this.mainData.item.filter((item) => {
        return item.item_type === 2 || item.item_type === 3;
      });
    },
  },
  created() {
    this.init();
  },
  methods: {
    addStaffChange(val) {
      this.staffCheckedData = val;
      if (val.length) {
        this.showBusinessPerson = false;
      }
    },
    init() {
      const oid = Number(this.$route.query.id);
      orderDetail({
        order_id: oid,
      }).then((res) => {
        if (res.error_code === 0) {
          // 将购买课时和赠送课时转化为数值型
          res.data.item.forEach((item) => {
            item.list.forEach((it) => {
              it.quantity = Number(it.quantity);
              it.give_product_quantity = Number(it.give_product_quantity);
              // 将每项课程的有效时间放到 item 中，方便数据回填
              if (it.course_end_time === 0) {
                item.efficient_time = "";
              } else {
                item.efficient_time = dateFormat(
                  "YYYY-mm-dd",
                  new Date(it.course_end_time * 1000)
                );
              }
            });
          });
          // 将后端返回的时间戳直接转化为对应的日期
          res.data.handle_time = res.data.handle_time
            ? dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(res.data.handle_time * 1000)
              )
            : "-";
          this.mainData = res.data;
          this.partiallyPay = res.data.completed_amount;
          this.staffCheckedData = res.data.belong;
          this.mainData.item.forEach((item) => {
            item.list.forEach((it) => {
              if (
                it.give_product_quantity > 0 ||
                Number(it.discount_amount) > 0
              ) {
                this.showStar = true;
              }
            });
          });
        }
      });
      getPaymentDetailApi({
        order_id: oid,
      }).then((res) => {
        let total = 0;
        res.data.list.map((item) => {
          item.payment_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(item.payment_time * 1000)
          );
          total = total + Number(item.payment_amount);
        });
        this.payLogTableTotal = total.toFixed(2);
        this.payLogTableData = res.data.list;
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
    handleGiveProductQuantity(it) {
      // 如果为空，赋初值为 0
      if (!it.give_product_quantity) {
        it.give_product_quantity = 0;
      }
      if (it.give_product_quantity > 0 || Number(it.discount_amount) > 0) {
        this.showStar = true;
      } else {
        this.showStar = false;
      }
    },
    handleRemark() {
      if (this.mainData.remark) {
        this.showRemark = false;
      }
    },
    // 提交编辑信息
    saveConfirm() {
      if (this.showStar || this.$route.query.type === "partially") {
        // 未填备注信息
        if (!this.mainData.remark) {
          this.showRemark = true;
          return false;
        }
      }
      if (this.$route.query.type === "complete") {
        const data = {};
        const list = [];
        data.order_id = this.mainData.order_id;
        this.mainData.item.map((item) => {
          item.list.map((it) => {
            list.push({
              order_item_id: it.item_id,
              give_quantity: String(it.give_product_quantity),
              effective_time: item.efficient_time
                ? item.efficient_time.slice(0, 10)
                : "",
            });
          });
        });
        data.item_list = list;
        const staffList = [];
        this.staffCheckedData.map((item) => {
          staffList.push(item.staff_id);
        });
        data.order_belong = staffList;
        data.remark = this.mainData.remark;
        // 未选业务人员
        if (!data.order_belong.length) {
          return (this.showBusinessPerson = true);
        }
        approvalRejectEditApi(data).then((res) => {
          if (res.error_code === 0) {
            this.init();
            this.$message.success({
              message: "修改成功",
            });
            setTimeout(() => {
              this.$router.push({
                name: "orderManageDetail",
                query: {
                  id: this.mainData.order_id,
                  from: "orderManageEdit",
                },
              });
            }, 1000);
          }
        });
      } else if (this.$route.query.type === "partially") {
        let content = this.$refs.editableOrderContent.tableData;
        let combo = content.filter((a) => {
          return a.type === "set" && !a.disabled;
        });
        let course = content.filter((a) => {
          return a.type === "course" && !a.disabled;
        });
        let product = content.filter((a) => {
          return a.type === "product" && !a.disabled;
        });
        // 总价对比已支付金额
        let payTotal = this.$refs.editableOrderContent.tableSumPrice;
        if (payTotal < Number(this.partiallyPay)) {
          this.$message({
            type: "warning",
            message: "课程总额小于已付金额！",
          });
          return false;
        } else if (payTotal === Number(this.partiallyPay)) {
          this.$confirm(
            "课程总额等于已付金额，本次提交会将订单标记为已完成状态，确定提交？",
            "提示",
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
            }
          )
            .then(() => {
              this.payEditSave(combo, course, product);
            })
            .catch();
        } else {
          this.payEditSave(combo, course, product);
        }
      }
    },
    payEditSave(combo, course, product) {
      let params = {
        order_id: this.mainData.order_id,
        combo: combo.map((item) => {
          return {
            combo_product_id: item.combo_product_id,
            item: item.item.map((it) => {
              let c = {
                option_id: it.option_id,
                quantity: String(it.quantity),
                discount_type: it.discount_type,
                discount: String(it.discount),
                give_quantity: String(it.give_quantity),
              };
              if (it.effective_time) {
                c.effective_time = it.effective_time;
              }
              return c;
            }),
          };
        }),
        course: course.map((item) => {
          let c = {
            course_id: item.course_id,
            option_id: item.course_spec_id,
            quantity: String(item.quantity),
            discount_type: item.discount_type,
            discount: String(item.discount),
            give_quantity: String(item.give_quantity),
          };
          if (item.effective_time) {
            c.effective_time = item.effective_time;
          }
          return c;
        }),
        product: product.map((item) => {
          return {
            product_id: item.product_id,
            quantity: String(item.quantity),
            unit_price: String(item.unit_price),
            discount: String(item.discount),
            subtotal: String(item.sum),
          };
        }),
        remark: this.mainData.remark,
      };
      let deleteIds = this.$refs.editableOrderContent.deleteIds;
      if (deleteIds.length > 0) {
        params.del_order_item_ids = deleteIds;
      }
      editPartiallyPayOrderApi(params).then((res) => {
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.$router.go(-1);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}

.detail-head {
  margin: 16px 72px;
}

.user-content {
  flex: 1;
  padding: 19px 20px;
  border: 1px solid #e1e5e9;
  border-radius: 4px;

  .title {
    font-size: 16px;
    color: #5c5d5e;
    margin-bottom: 30px;
    line-height: 16px;
    font-weight: bold;

    .name {
      padding-right: 10px;
      margin-right: 10px;
      border-right: 1px solid #e7e8ea;
    }
    .mobile {
      font-weight: normal;
    }
  }
  .info {
    margin-bottom: 0px;
  }
}

.table-wrap {
  margin: 0 72px;
  font-size: 12px;
  color: #5c5d5e;
  line-height: 42px;
  text-align: center;
  .table-title {
    font-size: 16px;
    color: #5c5d5e;
    text-align: left;
  }
  &.course {
    .th,
    .tr {
      display: flex;
      .td {
        flex: 1;
      }
      .td:nth-child(1) {
        flex: 1.5;
      }
      .td:nth-child(7) {
        flex: 2;
      }
      .td:nth-child(9) {
        flex: 0.5;
      }
    }
  }
  &.product {
    .th,
    .tr {
      display: flex;
      .td {
        flex: 1;
      }
      .td:nth-child(1) {
        flex: 1.5;
      }
      .td:nth-child(5) {
        flex: 2;
      }
      .td:nth-child(7) {
        flex: 0.5;
      }
    }
  }
  .th {
    background-color: #f2f6fa;
    margin-bottom: 10px;
    .td {
      font-weight: bold;
    }
  }
  .tr {
    border-bottom: 1px solid #e1e5e9;
    &:last-child {
      border-bottom: 0;
    }
    .td {
    }
  }
  .item {
    margin-bottom: 10px;
    border: 1px solid #e1e5e9;
    .title {
      padding-left: 28px;
      font-weight: bold;
      background: #f2f6fa;
      text-align: left;
    }
    /deep/ .tr .td:nth-child(4) .el-input__inner {
      padding: 0;
      text-align: center;
    }
    /deep/ .tr .td:nth-child(5) .el-input__inner {
      padding: 0;
      text-align: center;
    }
    /deep/ .tr .td:nth-child(6) .el-input__inner {
      padding: 0;
      text-align: center;
    }
    /deep/ .tr .td:nth-child(7) .el-input__inner {
      padding-left: 5px;
    }
    /deep/ .el-input {
      .el-input__inner {
        height: 30px !important;
      }
      .el-input-group__prepend {
        background: rgb(245, 247, 250);
        padding: 0 0 0 9px !important;
        line-height: 20px;
        & + .el-input__inner {
          border-left: 0;
          padding: 0;
          padding-left: 1px !important;
        }
        &:hover {
          cursor: not-allowed;
        }
      }
    }
    .date-wrap {
      padding-left: 34px;
      line-height: 42px;
      background-color: #f6fafc;
      color: #5c5d5e;
      font-size: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      i {
        color: #bebfc0;
        font-size: 14px;
        margin-left: 6px;
        cursor: pointer;
      }
    }
  }
}

.block {
  margin: 0 72px;
  border: 1px solid #d9dadb;
  border-radius: 4px;
  padding: 26px;
  margin-bottom: 20px;
  .title {
    font-size: 14px;
    color: #5c5d5e;
    margin-bottom: 21px;
  }
  .item {
    display: flex;
    line-height: 28px;
    margin-bottom: 12px;
    font-size: 12px;
    color: #5c5d5e;
    .label {
      min-width: 70px;
    }
    .content {
      flex: 1;
      .red {
        color: #f56c6c;
      }
      &.error {
        .box {
          &.active {
            border: 1px solid #f56c6c !important;
          }
        }
      }
      .box {
        display: inline-block;
        margin-right: 38px;
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        padding: 0 8px;
        &.active {
          border-color: #07d1aa;
        }
        .text {
          margin: 0 8px;
        }
        .input {
          font-size: 12px;
          color: #5c5d5e;
          width: 60px;
          border: 0;
        }
      }
    }
    .belong-wrap {
      .tag {
        display: inline-block;
        vertical-align: middle;
        background-color: #f6fafc;
        padding: 0 12px;
        border-radius: 4px;
        margin-right: 12px;
        white-space: nowrap;
        margin-bottom: 10px;
      }
      .btn {
        color: #07d1aa;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
  .sum-total-wrap {
  }
}

.pay-log-table {
  margin: 24px 72px;
  .title {
    font-size: 14px;
    color: #5c5d5e;
    margin: 16px 0;
  }
  .total {
    text-align: right;
    font-size: 18px;
    color: #5c5d5e;
    margin: 24px 0 18px 0;
    line-height: 24px;
    .number {
      color: #45b13b;
    }
  }
}

.foot-btn-wrap {
  margin: 0 72px;
  text-align: left;
  margin-bottom: 12px;
  .mwow-button-filled {
    margin-right: 10px;
  }
}
</style>
